import { Grid } from "@mui/material";
import ThankYouSurvey from "../../styles/illustrations/ThankYouSurvey.png";
import { Button } from "../ui/Button/Button";
import { Card } from "../ui/Card/Card";
import { Typography } from "../ui/Typography/Typography";
import "./ActionPlanSetupBanner.scss";

export interface ActionPlanSetupBannerProps {
  title: string;
  buttonLabel: string;
  description?: string;
  onClick?: () => void;
}

export const ActionPlanSetupBanner = ({
  title,
  buttonLabel,
  description,
  onClick,
}: ActionPlanSetupBannerProps) => {
  return (
    <Card>
      <Grid container spacing={0} className="ActionPlanSetupBanner">
        <Grid item sm={8} className="ActionPlanSetupBanner__content">
          <Typography
            desktop="h1"
            weight="bold"
            className="ActionPlanSetupBanner__title"
          >
            {title}
          </Typography>
          {description && (
            <Typography
              desktop="body1"
              className="ActionPlanSetupBanner__description"
            >
              {description}
            </Typography>
          )}
          <Button
            variant="contained"
            color="info"
            onClick={onClick}
            className="ActionPlanSetupBanner__button"
          >
            {buttonLabel}
          </Button>
        </Grid>
        <Grid item sm={4} className="ActionPlanSetupBanner__illustration">
          <img src={ThankYouSurvey} alt="Success illustration" />
        </Grid>
      </Grid>
    </Card>
  );
};
